import { render, staticRenderFns } from "./ContentAccordionModule.vue?vue&type=template&id=0596117e&"
import script from "./ContentAccordionModule.ts?vue&type=script&lang=ts&"
export * from "./ContentAccordionModule.ts?vue&type=script&lang=ts&"
import style0 from "./ContentAccordionModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports